import React, { useState } from "react";
import loginBg from "../images/loginbg.svg";
import logo from "../images/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import API from "../redux/actions/API";
import { authHeader } from "../functions/CoreFunctions";
import CustomButtonLoader from "./CustomComponents/CustomButtonLoader";
import { CustomAlertMessage } from "../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import SendOtp from "./SendOtp";
import UpdatePassword from "./UpdatePassword";

function ForgetPassword() {
  const [flag, setFlag] = useState(true);
  const [loading, setLoading] = useState(false);
  const [reloading, setReLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const history = useNavigate();
  const [email, setEmail] = useState("");

  return (
    <div>
      <Container fluid>
        <Row>
          <Col md="5" lg="6" className="loginBg-end">
            <img alt="Logo" src={loginBg} className="w-100" />
          </Col>

          <Col md="5" lg="6" className="d-flex">
            <div className="login-form">
              <img alt="Logo" className="logo" src={logo} />
              {flag ? (
                <SendOtp
                  loading={loading}
                  setLoading={setLoading}
                  enqueueSnackbar={enqueueSnackbar}
                  setFlag={setFlag}
                  useFormik={useFormik}
                  Yup={Yup}
                  API={API}
                  authHeader={authHeader}
                  CustomButtonLoader={CustomButtonLoader}
                  CustomAlertMessage={CustomAlertMessage}
                  setEmail={setEmail}
                />
              ) : (
                <UpdatePassword
                  loading={loading}
                  reloading={reloading}
                  setReLoading={setReLoading}
                  setLoading={setLoading}
                  enqueueSnackbar={enqueueSnackbar}
                  history={history}
                  useFormik={useFormik}
                  Yup={Yup}
                  API={API}
                  authHeader={authHeader}
                  email={email}
                  CustomButtonLoader={CustomButtonLoader}
                  CustomAlertMessage={CustomAlertMessage}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ForgetPassword;
